import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SITE_URL = 'https://www.furlongfriend.com';
const DEFAULT_TITLE = 'Furlong Friend — Your Racecard, Ranked in Seconds';
const DEFAULT_DESCRIPTION =
  'Upload your Past Performance CSV and get AI-powered handicapping rankings in seconds. Trained on tens of thousands of races. Try free for 7 days.';

const PAGE_META = {
  '/': {
    title: DEFAULT_TITLE,
    description: DEFAULT_DESCRIPTION
  },
  '/pricing': {
    title: 'Pricing | Furlong Friend',
    description:
      'Start with a 7-day free trial, grab a $4.99 day pass for single events, or get unlimited handicapping analysis for $19.99/month.'
  },
  '/about': {
    title: 'About | Furlong Friend',
    description:
      'The story behind Furlong Friend — an AI handicapping tool built from techniques a father passed down, trained on tens of thousands of races.'
  },
  '/faq': {
    title: 'FAQ | Furlong Friend',
    description:
      'Answers to common questions about Furlong Friend: how the AI rankings work, what data you need, pricing, privacy, and more.'
  },
  '/contact': {
    title: 'Contact | Furlong Friend',
    description: 'Get in touch with the Furlong Friend team for support, general questions, or business inquiries.'
  },
  '/terms': { title: 'Terms of Service | Furlong Friend' },
  '/privacy': { title: 'Privacy Policy | Furlong Friend' },
  '/login': { title: 'Sign In | Furlong Friend' },
  '/signup': { title: 'Sign Up | Furlong Friend' },
  '/dashboard': { title: 'Race Breakdown | Furlong Friend' }
};

function setMetaContent(selector, content) {
  const el = document.querySelector(selector);
  if (el && content) el.setAttribute('content', content);
}

// Keeps document.title, meta description, and the canonical URL in sync with
// the current route. CRA serves one static index.html for every path, so
// without this all pages share the landing page's title/canonical.
function SeoTags() {
  const { pathname } = useLocation();

  useEffect(() => {
    const meta = PAGE_META[pathname] || PAGE_META['/'];

    document.title = meta.title;
    setMetaContent('meta[name="description"]', meta.description || DEFAULT_DESCRIPTION);

    // Canonical: path only, never query strings (?family=1, ?success=true, …)
    const href = pathname === '/' ? `${SITE_URL}/` : `${SITE_URL}${pathname}`;
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      document.head.appendChild(link);
    }
    link.setAttribute('href', href);
  }, [pathname]);

  return null;
}

export default SeoTags;
